export const ADD_FILTERS = 'ADD_FILTERS';

export const addFilters = (context, filterType, filterValues) => ({
  type: ADD_FILTERS,
  context,
  filterType,
  filterValues,
});
